<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/users' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header>
        <h1>{{ $t('edit') }} {{ $t('user') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm" >
            <div class="row">
                <span class="label">{{ $t('user') }}</span>
                <div class="inputs">
                    <heim-input :label="$t('name')  + '*'" name="name" :placeholder="$t('name')" v-model="user.name" v-validate="'required'"></heim-input>
                     <span v-show="errors.has('name')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('name') }}</span>
                    <heim-input  :label="$t('email')  + '*'" name="email" placeholder="" v-model="user.email" v-validate="'required|email'"></heim-input>
                     <span v-show="errors.has('email')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('email') }}</span>
                </div>
            </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
    <heim-card>
      <header>
        <h1>{{ $t('changePassword') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleFormPassword">
            <div class="row">
                <span class="label">{{ $t('newPassword') }}</span>
                <div class="inputs">
                    <heim-input :label="$t('newPassword')" type="password" name="password" v-model="password" v-validate="'min:5'"></heim-input>
                    <span v-show="errors.has('password')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('password') }}</span>
                </div>
            </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
    <heim-card class="danger-zone">
      <header>
        <h1>{{ $t('dangerZone') }}</h1>
      </header>
      <main>
        <div class="row">
          <div class="lab">
            <p><strong>{{ $t('removingUser') }}</strong></p>
          </div>
          <div class="input">
            <button @click="deleteForm" class="paper-action remove"><heim-icon class="icon" icon="close"></heim-icon><span>{{ $t('remove') }}</span></button>
          </div>
        </div>
      </main>
      <v-dialog/>
    </heim-card>
  </section>
</template>

<script>
import Vue from "vue";
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import { mapState } from "vuex";
import VModal from "vue-js-modal";
Vue.use(VModal, { dialog: true });

export default {
  name: "UsersEdit",
  components: {
    HeimInput,
    HeimButton,
    HeimCard,
    HeimIcon
  },
  data() {
    return {
      password: ""
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.$store.dispatch("getUser", id);
    this.$watch(
      vm => vm.user,
      val => {
        this.$store.dispatch("setTitle", `Edit user - ${val.name}`);
      }
    );
  },
  computed: {
    ...mapState({
      user: state => state.usersState.user
    })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("updateUser", {
        id: this.user.id,
        user: {
          name: this.user.name,
          email: this.user.email
        }
      });

      this.$validator.validateAll().then(result => {
        if (result && data.id) {
          this.$store.dispatch("setToastMessage", {
            message: "updateSuccessful"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/users/${this.user.id}/details` });
        }
      });
    },

    async handleFormPassword() {
      const data = await this.$store.dispatch("updatePassword", {
        id: this.user.id,
        user: {
          password: this.password
        }
      });

      if (data.id) {
        this.$store.dispatch("setToastMessage", {
          message: "updateSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
        this.$router.push({ path: `/users/${this.user.id}/details` });
      }
    },
    async removeUser() {
      const data = await this.$store.dispatch("deleteUser", {
        id: this.user.id
      });
      if (data.success) {
        this.$store.dispatch("setToastMessage", {
          message: "deleteSuccessful"
        });
        this.$store.dispatch("setToastMode", {});
        this.$store.dispatch("setOpenToast", { opened: true });
        this.$router.push({ path: `/users` });
      }
    },
    deleteForm() {
      this.$modal.show("dialog", {
        title: "Suppression",
        text: "Etes-vous sur de vouloir supprimer cet utilisateur ?",
        buttons: [
          {
            title: "Oui",
            handler: () => {
              this.removeUser();
            }
          },
          {
            title: "Non",
            default: true
          }
        ]
      });
    }
  }
};
</script>

<style>
input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
</style>

<style scoped>
.empty-user-admin {
  display: flex;
  flex-direction: column;
  height: 15em;
}
.empty-user-admin .bg {
  background-image: url("/img/undraw_add_user_ipe3.svg");
  background-size: 100% 100%;
  background-position: center;
  height: 100%;
  margin-bottom: 1em;
}
.empty-user-admin .message {
  justify-content: center;
  display: block;
  text-align: center;
}

.paper-card {
  margin-bottom: 1.5em;
}

.site-endpoints {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0.8em 1em;
  border-bottom: 1px solid #eeeeee;
}

.endpoint-url {
  width: 100%;
}

.integrity-key {
  width: 100%;
}

.site-endpoints .endpoint-action-button {
  display: flex;
  align-items: center;
  margin-right: 1em;
}

.site-endpoints .endpoint-action-button .update .icon {
  margin: 0 0.5em;
}

.site-endpoints .endpoint-action-button .remove {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.user-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
}

.user-users,
.select-user {
  width: 100%;
}

.select-user .user-list {
  height: 16em;
  overflow-y: auto;
}

.select-user .custom-input {
  position: relative;
  width: 100%;
}

.select-user .custom-input .icon-button {
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 4px;
}

.users {
  width: 100%;
  padding: 0.6rem 1rem;
}

.users .user {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 8px;
}
.users .user:hover {
  background-color: var(--heim-grey-color);
}

.users .cell {
  padding: 0.3rem 0.5rem;
}

.users .user .info {
  flex: 1;
}

.users .user .info .email {
  font-size: 0.8rem;
  font-weight: 600;
  word-break: break-word;
}

.users .user .profile {
  display: none;
}

.users .user .avatar {
  font-size: 1.5rem;
  font-weight: 600;
  background-color: var(--heim-secondary-color);
  color: var(--heim-white-color);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  border: solid thin var(--heim-grey-color);
  cursor: default;
}

.users .remove .paper-action {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.users .user .info .label {
  font-size: 1.2em;
  font-weight: 400;
}

.danger-zone {
  border-top: solid 4px var(--heim-red-color);
}

.danger-zone h1 {
  color: var(--heim-red-color);
}

.danger-zone .remove {
  color: var(--heim-red-color);
  border-color: var(--heim-red-color);
}

.label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
/* Wide layout: when the viewport width is bigger than 460px, layout
  changes to a wide layout. */
@media (min-width: 460px) {
  .ctn {
    margin: 1em 10em 0 10em;
  }

  .user-users {
    margin-right: 1em;
  }

  .user-users {
    width: 58%;
  }
  .select-user {
    width: 40%;
  }

  .users .user .profile {
    display: block;
  }

  .select-user .custom-input {
    width: 60%;
  }
}
</style>
